import { makeStyles } from "@mui/styles";

const performanceStyle = makeStyles((theme) => ({
  countingContainer: {
    "& .MuiBox-root": {
      display: "flex",
    //   justifyContent: "center",
      alignItems: "center",
      padding: "20px 0",
      borderBottom: "1px solid #e4e4e4",
    },
    "& .MuiTypography-h3 ": {
      fontSize: "40px !important",
      fontWeight: "600 !important",
      color: "#008374",
    },
  },
}));

export default performanceStyle;
